import "./tab0.scss";
import * as React from "react";
import DotIndicator from "../../../../../../../../ui/dotindicator/dotindicator";
import DatePicker from "../../../../../../../../ui/datepicker/datepicker";
import Button from "../../../../../../../../core/button/button";
import Alert from "../../../../../../../../ui/alert/alert";

const Tab0 = () => {
    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mt-1 mb-1">
                    <DotIndicator/>
                    <span>تنظیمات کلی</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">عنوان کمپین</h6>
                    <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال:عسل"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3"></div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="name">زمان شروع کمپین</label>
                    <div className="d-flex justify-content-end align-items-center Date-Picker-Box">
                        <DatePicker/>
                        <Button type={"secondary"} action={() => {

                        }} responsive={false}>انتخاب تاریخ</Button>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <label htmlFor="name">زمان پایان کمپین</label>
                    <div className="d-flex justify-content-end align-items-center Date-Picker-Box">
                        <DatePicker/>
                        <Button type={"secondary"} action={() => {

                        }} responsive={false}>انتخاب تاریخ</Button>
                    </div>
                </div>
                <div className="col-12 mb-4">
                    <h6 className="pt-4 pb-1">ملاحظات انتشار</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={5}></textarea>
                </div>
                <Alert type={"Danger"}>
                    <img src={require("../../../../../../../../assets/images/icons/RoundedRedTick.svg").default}
                         className="img-fluid ms-3" alt=""/>
                    تمامی زمان های مشخص شده در سایت به صورت حدودی بوده و بعد از هماهنگی با بلاگر زمان دقیق مشخص می شود .
                </Alert>
            </div>
        </div>
    );
}

export default Tab0;